import type { GetServerSidePropsContext } from 'next';

import MarketNonLoginPopup from '~/components/MarketNonLoginPopup';
import { TrackPage } from '~/components/TrackEvent';
import { useCurrentUser } from '~/domains/auth/queries';
import { getSnowdonJwt } from '~/domains/auth/utils';
import EntryProductSearch from '~/domains/search/EntryProductSearch';
import { useRouterQueryByKey } from '~/hooks/url';
import { prefetchReactQueryData } from '~/libs/reactQuery';

import { SearchContainer } from './components/SearchContainer';
import { SearchLayout } from './components/SearchLayout';

const SearchPage = () => {
  const searchText = useRouterQueryByKey('searchText', 'string');
  const { isLoggedIn } = useCurrentUser();

  if (!searchText) {
    return <EntryProductSearch />;
  }

  return (
    <>
      <TrackPage page="캐시노트마켓/search" />
      <SearchContainer />
      {!isLoggedIn && <MarketNonLoginPopup />}
    </>
  );
};

SearchPage.Layout = SearchLayout;

export default SearchPage;

export const getServerSideProps = async (
  context: GetServerSidePropsContext,
) => {
  const { searchText } = context.query;

  const token = getSnowdonJwt(context);

  if (!token || !searchText) {
    return {
      props: {},
    };
  }

  const { dehydratedState } = await prefetchReactQueryData({
    queries: [
      [
        '/api/market-place/v1/search/products',
        {
          productName: decodeURIComponent(searchText as string),
        },
      ],
    ],
    fetchOptions: {
      headers: {
        'X-Client-Auth-Token': token,
      },
    },
  });

  return {
    props: {
      dehydratedState,
    },
  };
};
